/**
 * Codifica una cadena u objeto a Base64 con soporte nativo para Unicode (UTF-8).
 * 
 * @param {Object|string} data Datos a codificar
 * @returns {string} Cadena en Base64
 */
export const encodeBase64 = (data) => {
  try {
    const jsonString = typeof data === "object" ? JSON.stringify(data) : String(data);
    
    // Convertir la cadena a bytes UTF-8 antes de aplicar btoa
    const utf8Bytes = new TextEncoder().encode(jsonString);
    let binaryString = "";
    
    for (let i = 0; i < utf8Bytes.length; i++) {
      binaryString += String.fromCharCode(utf8Bytes[i]);
    }

    return btoa(binaryString);
  } catch (error) {
    console.error("❌ [BASE64 ENCODE ERROR]: Fallo al codificar payload:", error);
    throw new Error("Error al procesar la información en formato Base64.");
  }
};

/**
 * Decodifica una cadena Base64 a objeto o texto plano.
 * 
 * @param {string} base64String Cadena codificada
 * @returns {Object|string}
 */
export const decodeBase64 = (base64String) => {
  try {
    const binaryString = atob(base64String);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const jsonString = new TextDecoder().decode(bytes);

    try {
      return JSON.parse(jsonString);
    } catch {
      return jsonString;
    }
  } catch (error) {
    console.error("❌ [BASE64 DECODE ERROR]: Fallo al decodificar cadena Base64:", error);
    throw new Error("Error al decodificar la respuesta del servidor.");
  }
};